<template>
  <vx-card v-if="role" no-shadow>
    <h2 class="mb-6">General</h2>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Identifier</span>
      </div>
      <div class="vx-col">
        <span>{{ role.id }}</span>
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Title</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-input
          label=""
          :disabled="!hasPermission('life.admin.roles.edit')"
          v-model="role.title"
          class="w-full"
        />
      </div>
    </div>

    <div class="vx-row mb-8">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Description</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-textarea
          :disabled="!hasPermission('life.admin.roles.edit')"
          placeholder="Description..."
          v-model="role.description"
          class="w-full"
        />
      </div>
    </div>

    <vs-divider />

    <div class="vx-col lg:w-1/1 w-full">
      <h5 class="mb-6">LIFE App chat</h5>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Roles that this role can chat with</span>
      </div>
      <div class="vx-col">
        <vs-select
          :disabled="!hasPermission('life.admin.roles.edit')"
          class=""
          multiple
          v-model="role.chatRoleIds"
        >
          <vs-select-item
            :key="index"
            :value="item.id"
            :text="item.title + ' (' + item.id + ')'"
            v-for="(item, index) in items"
          />
        </vs-select>
      </div>
    </div>

    <vs-divider />

    <div class="vx-col lg:w-1/1 w-full">
      <h5 class="mb-6">Role scope</h5>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Limit role to entity type</span>
      </div>
      <div class="vx-col">
        <vs-select
          :disabled="!hasPermission('life.admin.roles.edit')"
          class=""
          v-model="role.entityType"
        >
          <vs-select-item
            :key="index"
            :value="item.value"
            :text="item.text"
            v-for="(item, index) in entityTypes"
          />
        </vs-select>
      </div>
    </div>
    <div class="flex flex-wrap items-center justify-end">
      <vs-button
        @click="saveInfo"
        v-if="hasPermission('life.admin.roles.edit')"
        id="save-button"
        class="ml-auto mt-2"
        >Save Changes</vs-button
      >
    </div>
  </vx-card>
</template>

<script>
export default {
  components: {},
  props: {
    role: Object,
  },
  data() {
    return {
      items: [],
      entityTypes: [
        //{ text: "No limit", value: 0 },
        { text: "Venue", value: 1 },
        { text: "Region", value: 3 },
        { text: "Country", value: 2 },
      ],
    };
  },
  methods: {
    getItems: function () {
      this.$vs.loading();

      this.$http
        .get(process.env.VUE_APP_API + "/Idam/Roles") // query?
        .then((resp) => {
          console.log("Got roles", resp.data);
          this.items = resp.data;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    saveInfo() {
      console.log("Save info: ", this.role);
      this.$vs.loading();

      const url = process.env.VUE_APP_API + "/Idam/Roles";
      this.$http
        .put(url, this.role)
        .then((resp) => {
          console.log(resp.data);

          if (resp.data.success === true) {
            this.$vs.notify({
              color: "success",
              title: "Success",
              text: "Role updated",
            });

            this.$emit("updateRole", this.role);
          } else {
            console.log(resp.data.error);

            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: "Could not update role: " + resp.data.error,
            });
          }
        })
        .catch((err) => {
          this.$vs.notify({
            color: "danger",
            title: "Error",
            text: "Could not update role" + err,
          });
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
  },
  created() {
    this.getItems();
  },
};
</script>
